export {
  axisTop,
  axisRight,
  axisBottom,
  axisLeft
} from "./axis";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-axis/src/index.js
// module id = 1313
// module chunks = 0